import { render, staticRenderFns } from "./PubbleChat.vue?vue&type=template&id=00c16d04&scoped=true&"
import script from "./PubbleChat.vue?vue&type=script&lang=js&"
export * from "./PubbleChat.vue?vue&type=script&lang=js&"
import style0 from "./PubbleChat.vue?vue&type=style&index=0&id=00c16d04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c16d04",
  null
  
)

export default component.exports